import {AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn} from '@angular/forms';
import _ from 'lodash';

/**
 * async validator to check if control value is forbidden
 * @param extensions
 */
export function extensionValidator(extensions: string[]): AsyncValidatorFn {
  return (control: AbstractControl): Promise<ValidationErrors | null> => {
    const file: any = _.first(control.value);
    if (!file) {
      return Promise.resolve(null);
    }

    const fileExtension = _.last(_.split(_.get(file, 'type'), '/'));

    // if file type && allowed
    if (fileExtension && _.includes(extensions, fileExtension)) {
      return Promise.resolve(null);
    }

    // if no type, try to read firm
    return new Promise((resolve) => {
      const reader = new FileReader();
      const blob = file.slice(0, 8); // read enough bytes from file

      reader.onloadend = () => {
        const arr = new Uint8Array(reader.result as ArrayBuffer);
        const hex = Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('');

        const inferredType = detectFileTypeFromMagicNumber(hex);
        if (inferredType && _.includes(extensions, inferredType)) {
          resolve(null);
        } else {
          resolve({ extension: { options: _.join(extensions, ', ') } });
        }
      };

      reader.onerror = () => resolve(null);
      reader.readAsArrayBuffer(blob);
    });
  };
}

// file type according to magic numbers
function detectFileTypeFromMagicNumber(hex: string): string | null {
  const signatures: Record<string, string[]> = {
    pdf: ['25504446'], // PDF
    jpg: ['ffd8ff'], // JPG
    jpeg: ['ffd8ff'], // JPEG
    png: ['89504e47'], // PNG
    gif: ['47494638'], // GIF
    zip: ['504b0304'], // ZIP (used by DOCX, XLSX, PPTX)
    docx: ['504b0304'], // DOCX
  };

  for (const [ext, sigs] of Object.entries(signatures)) {
    if (sigs.some(sig => hex.startsWith(sig))) {
      return ext;
    }
  }

  return null;
}
